console.log('✅ home-page-request-quote.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import { getLinksTranslationByKey } from '../../js/router-routes-manager.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';

import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

let _tempTextTranslator = null;
export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

export async function buildComponentHomePageRequestQuote() {
  console.log(`🔄 Building Component: HomePageRequestQuote - lang: ${appState.SiteLanguageCookie}`);

  try {
    await initTempTextTranslator(appState.SiteLanguageCookie);
    await initTempLinksTranslator(appState.SiteLanguageCookie);
    // const tempTranslator = await loadTextTranslations(lang);

    // Destructure just the keys you need, giving them your desired local names
    const {
      keyHomePageTenderSectionTitle: lblHomePageTenderSectionTitle,
      keyHomePageTenderSectionSubtitle: lblHomePageTenderSectionSubtitle,
      keyHomePageTenderSectionExamplePlaceholder: lblHomePageTenderSectionExamplePlaceholder,
      keyHomePageTenderSectionSubmitButton: lblHomePageTenderSectionSubmitButton,
    } = _tempTextTranslator;

    //const {
    //    keySubcategories: linkSubcategories,

    //}
    //    = _tempLinksTranslator;

    //// ✅ Fetch all translations in parallel
    //const [
    //    lblHomePageTenderSectionTitle,
    //    lblHomePageTenderSectionSubtitle,
    //    lblHomePageTenderSectionExamplePlaceholder,
    //    lblHomePageTenderSectionSubmitButton
    //] = await Promise.all([
    //    getTextTranslationByKey("keyHomePageTenderSectionTitle", lang),
    //    getTextTranslationByKey("keyHomePageTenderSectionSubtitle", lang),
    //    getTextTranslationByKey("keyHomePageTenderSectionExamplePlaceholder", lang),
    //    getTextTranslationByKey("keyHomePageTenderSectionSubmitButton", lang)
    //]);

    // Image source

    // Build the trending listings HTML
    const html = `
            <center>
                <div class="RequestQuote-wrapper">
                <div class="RequestQuote-grid">

                    <div class="RequestQuote-image-cell">
                        <img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/pg/hm/shipping.jpg" width="520" height="350" alt="Request Quote" loading="lazy">
                    </div>

                    <div class="RequestQuote-content-cell">
                        <span class="form-RequestQuote-title">${lblHomePageTenderSectionTitle}</span>
                        <label class="form-RequestQuote-field-subheading">${lblHomePageTenderSectionSubtitle}</label>

                        <div class="form-RequestQuote-field-wrap">
                            <textarea id="TextBoxQuote" class="textboxQuoteHomePage" 
                                      placeholder="${lblHomePageTenderSectionExamplePlaceholder}">
                            </textarea>
                        </div>

                        <button id="btnSubmitQuote" class="my-btn my-basic-width-100 my-basic-padding-10">
                            ${lblHomePageTenderSectionSubmitButton}
                        </button>
                    </div>

                </div>
            </div>

            </center>
                      
        `;

    console.log('✅ HomePageRequestQuote built successfully.');

    // Register event listeners
    registerEventListenerToAttach(async () => attachEventListenersHomePageRequestQuote());

    return html;
  } catch (err) {
    console.error('❌ Error building HomePageRequestQuote:', err);
    return '<div>Error loading trending listings</div>';
  }
}

async function attachEventListenersHomePageRequestQuote() {
  try {
    const btnSubmitQuote = document.querySelector('#btnSubmitQuote');

    btnSubmitQuote?.addEventListener('click', async () => {
      await submitQuoteRequest();
    });

    console.log('✅ RequestQuoteComponent event listeners attached.');
  } catch (error) {
    console.error('❌ Error attaching event listeners to RequestQuoteComponent:', error);
  }
}

async function submitQuoteRequest() {
  const btnSubmitQuote = document.querySelector('#btnSubmitQuote');
  const textBoxQuote = document.querySelector('#TextBoxQuote');

  // Add the loading class
  btnSubmitQuote.classList.add('myloading');

  try {
    const quoteText = textBoxQuote?.value.trim();
    if (quoteText) {
      //  submitQuoteRequest(quoteText);
    } else {
      alert('Please enter a valid quote.');
    }

    console.log('Submitting quote request:', quoteText);
    // TODO: Add your quote submission logic here (e.g., API call)
    alert('Quote submitted: ' + quoteText);
  } catch (error) {
    console.error('❌ Error submitting quote request:', error);
  }

  setTimeout(() => {
    //  closeDropdown();

    btnSubmitQuote.classList.remove('myloading');
  }, 2000);
}
